import { useQuery } from '@tanstack/vue-query'
import { Ref } from 'vue'

import { explorerApi } from '~/api/client'
import { EvmBlockInfo, EvmBlockListInfo } from '~/api/repository'
import { blockListKey } from '~/api/service/query-keys.const'
import { IPagination } from '~/types/pagination.type'

export const useFetchBlockList = (pagination: Ref<IPagination>) => {
  return useQuery([ ...blockListKey, pagination ], (): Promise<ViewBlockListInfo> => {
    return explorerApi.blockController.getBlockList({
      requestBody: {
        page: pagination.value.page,
        size: pagination.value.rowPerPage
      }
    }).then((res) => {
      return blockListDto(res as EvmBlockListInfo)
    })
  })
}

export type ViewBlockInfo = EvmBlockInfo & {
  unixTimeStamp: string;
  gasUsed: string;
  gasUsedPercent: string;
  gasLimit: string;
  blockReward: string;
  burntFees: string;
  burntFeesPercent: string;
  baseFeePerGasGwei: string;
}

type ViewBlockListInfo = EvmBlockListInfo & {
  totalCount: string;
  viewCount: string;
  blockList: Array<ViewBlockInfo>;
}

const blockListDto = (blockList: EvmBlockListInfo): ViewBlockListInfo => {
  return {
    ...blockList,
    totalCount: setComma(blockList.TCNT),
    viewCount: setComma(blockList.VCNT),
    blockList: blockList.BLKLIST.map((block: EvmBlockInfo) => {
      return {
        ...block,
        unixTimeStamp: secondsToDate(block.UT),
        gasUsed: setComma(block.GU),
        gasUsedPercent: block.GUP,
        gasLimit: setComma(block.GL),
        blockReward: setComma(setDigits(block.BR, 10)),
        burntFees: setComma(setDigits(block.BF, 8)),
        burntFeesPercent: block.BFP,
        baseFeePerGasGwei: setComma(setDigits(block.BFPGG, 10))
      }
    })
  }
}